<form id="daten_kraftfahrzeugdaten" class="daten-section" [formGroup]="formGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective">
  <div class="row">
    <div class="col col-xs-12 col-sm-12 mb-3" *ngIf="showHeader">
      <div class="header"><strong>Fahrzeug {{ risikoIndex + 1 }} ({{ marke.value?.Value }} {{ modell.value }})</strong></div>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <div *ngIf="complete; else _fahrzeugart">
        <div class="input">
          <label class="input__label" [for]="idprefix + '_fahrzeugart_' + risikoIndex">Fahrzeugart:</label>
          <mat-form-field>
            <input matInput [id]="idprefix + '_fahrzeugart_' + risikoIndex" [value]="fahrzeugart.value?.Value" disabled>
          </mat-form-field>
        </div>
      </div>
      <ng-template #_fahrzeugart>
        <div *ngIf="motorrad; then fahrzeugartMotorrad; else fahrzeugartKfz"></div>
        <ng-template #fahrzeugartMotorrad>
          <div class="input_radio">
            <app-label [control]="fahrzeugart" [for]="idprefix + '_fahrzeugart_' + risikoIndex">{{ expertMode ? 'Art des Zweirades' : 'Welche Art von Zweirad wollen Sie versichern?' }}</app-label>
            <mat-radio-group [id]="idprefix + '_fahrzeugart_' + risikoIndex" formControlName="fahrzeugart">
              <mat-radio-button *ngFor="let fa of getFahrzeugarten() | async" [value]="fa">{{ fa.Value }}</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="fahrzeugart.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
          </div>
        </ng-template>
        <ng-template #fahrzeugartKfz>
          <div class="custom_select">
            <app-label [control]="fahrzeugart" class="custom-select__label" [for]="idprefix + '_fahrzeugart_' + risikoIndex">{{ expertMode ? 'Fahrzeugart' : 'Welche Art von Fahrzeug wollen Sie versichern?' }}</app-label>
            <mat-form-field>
              <mat-select [id]="idprefix + '_fahrzeugart_' + risikoIndex" [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" formControlName="fahrzeugart" [compareWith]="lookupService.compareValues">
                <mat-option *ngFor="let fa of getFahrzeugarten() | async" [value]="fa">{{ fa.Value }}</mat-option>
              </mat-select>
              <mat-error *ngIf="fahrzeugart.hasError('required')">{{ 'SELECTREQUIRED' | translate }}</mat-error>
            </mat-form-field>
            <div class="row" *ngIf="showMbvInfoWohnMobile">
              <div class="col col-xs-12 col-sm-12">
                <div class="label-infotext" *ngIf="translateService.get(expertMode ? 'MBVINFOEXPERT' : 'MBVINFO') | async as result" [innerHTML]="result"></div>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-template>
    </div>
    <div class="col col-xs-12 col-sm-12" *ngIf="showEurotaxAbfrage">
      <div class="row">
        <div class="col col-xs-12 col-sm-12">
          <div class="text_info">
            Nützen Sie die Eurotax-Abfrage, um den Neuwertlistenpreis Ihres Fahrzeuges zu erhalten.
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12 text-right" *ngIf="showEurotaxAbfrage">
          <button mat-button class="button--primary icon--after icon--right" (click)="eurotaxListDialogService.openDialog($event, this)">Eurotax-Abfrage starten</button>
        </div>
      </div>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <div *ngIf="complete; else _marke">
        <div class="input">
          <label class="input__label" [for]="idprefix + '_marke_' + risikoIndex">Marke:</label>
          <mat-form-field>
            <input matInput [id]="idprefix + '_marke_' + risikoIndex" [value]="marke.value?.Value" disabled>
          </mat-form-field>
        </div>
      </div>
      <ng-template #_marke>
        <div class="custom_select">
          <app-label [control]="marke" class="custom-select__label" [for]="idprefix + '_marke_' + risikoIndex">{{ expertMode ? 'Marke:' : motorrad ? 'Welche Marke hat Ihr Zweirad?' : 'Welche Marke hat Ihr Fahrzeug?' }}</app-label>
          <mat-form-field>
            <input type="text" matInput [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" formControlName="marke" required [matAutocomplete]="autoGroup">
            <mat-autocomplete #autoGroup="matAutocomplete" [displayWith]="lookupService.displayValue">
              <mat-optgroup *ngFor="let group of markeGroupOptions | async" [label]="group.letter">
                <mat-option *ngFor="let value of group.values" [value]="value">
                  {{ value.Value }}
                </mat-option>
              </mat-optgroup>
            </mat-autocomplete>
            <mat-error *ngIf="marke.hasError('lookupValue')">{{ 'SELECTREQUIRED' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </ng-template>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <div *ngIf="complete && showSonstigeMarke; else _sonstigeMarke">
        <div class="input">
          <label class="input__label" [for]="idprefix + '_sonstigeMarke_' + risikoIndex">Welche Marke?</label>
        </div>
        <mat-form-field>
          <input matInput [id]="idprefix + '_sonstigeMarke_' + risikoIndex" [value]="sonstigeMarke.value" disabled>
        </mat-form-field>
      </div>
    </div>
    <ng-template #_sonstigeMarke>
      <div class="input" *ngIf="showSonstigeMarke">
        <app-label [control]="sonstigeMarke" class="input__label" [for]="idprefix + '_sonstigeMarke_' + risikoIndex">Welche Marke?</app-label>
        <mat-form-field>
          <input matInput [id]="idprefix + '_sonstigeMarke_' + risikoIndex" [maxlength]="50" formControlName="sonstigeMarke">
          <mat-error *ngIf="sonstigeMarke.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
        </mat-form-field>
      </div>
    </ng-template>
    <div class="col col-xs-12 col-sm-12">
      <div *ngIf="complete; else _modell">
        <div class="input">
          <label class="input__label" [for]="idprefix + '_modell_' + risikoIndex">Handelsbezeichnung:</label>
          <mat-form-field>
            <input matInput [id]="idprefix + '_modell_' + risikoIndex" [value]="modell.value" disabled>
          </mat-form-field>
        </div>
      </div>
      <ng-template #_modell>
        <div class="input">
          <app-label [control]="modell" class="input__label" [for]="idprefix + '_modell_' + risikoIndex">{{ expertMode ? 'Handelsbezeichnung' : 'Welche Handelsbezeichnung hat Ihr Fahrzeug?' }}</app-label>
          <mat-form-field>
            <input matInput [id]="idprefix + '_modell_' + risikoIndex" formControlName="modell">
            <mat-error *ngIf="modell.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </ng-template>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <div *ngIf="complete; else _erstzulassungsdatum">
        <div class="input">
          <label class="input-date-picker__label" [for]="idprefix + '_erstzulassungsdatum_' + risikoIndex">Erstzulassungsdatum:</label>
          <mat-form-field>
            <input matInput [id]="idprefix + '_erstzulassungsdatum_' + risikoIndex" [value]="erstzulassungsdatum.value | date" disabled>
          </mat-form-field>
        </div>
      </div>
      <ng-template #_erstzulassungsdatum>
        <div class="input">
          <ng-template #risikoErstzulassungsdatumLabelTemplate>
            <app-label [control]="erstzulassungsdatum" class="input-date-picker__label" [for]="idprefix + '_erstzulassungsdatum_' + risikoIndex">{{ expertMode ? 'Erstzulassungsdatum' : 'Welche Erstzulassung hat Ihr Fahrzeug?' }}</app-label>
          </ng-template>
          <div *ngIf="expertMode; else risikoErstzulassungsdatumInfoLabel">
            <ng-template [ngTemplateOutlet]="risikoErstzulassungsdatumLabelTemplate"></ng-template>
          </div>
          <ng-template #risikoErstzulassungsdatumInfoLabel>
            <div class="text_info">
              <ng-template [ngTemplateOutlet]="risikoErstzulassungsdatumLabelTemplate"></ng-template>
              <div class="info">
                <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('ERSTZULASSUNGSDATUMINFO', { fahrzeugArt: motorrad ? 'Motorräder' : 'Kfz' }) | async) as res" (click)="popupService.openInfoPopup(res)"></div>
              </div>
            </div>
          </ng-template>
          <mat-form-field>
            <input matInput [id]="idprefix + '_erstzulassungsdatum_' + risikoIndex" [matDatepicker]="erstzulassungsdatumPicker" [min]="erstzulassungsdatumMinDate" [max]="dateService.getErstzulassungsdatumMaxDate()" placeholder="TT.MM.JJJJ" [formControl]="erstzulassungsdatum">
            <mat-datepicker-toggle matSuffix [for]="erstzulassungsdatumPicker"></mat-datepicker-toggle>
            <mat-datepicker #erstzulassungsdatumPicker></mat-datepicker>
            <mat-error *ngIf="erstzulassungsdatum.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
            <mat-error *ngIf="erstzulassungsdatum.hasError('baujahrMin')">{{ 'MINVALUE' | translate:{'value': baujahrBeginn.value} }}</mat-error>
            <mat-error *ngIf="erstzulassungsdatum.hasError('baujahrMax')">{{ 'MAXVALUE' | translate:{'value': baujahrEnde.value} }}</mat-error>
            <mat-error *ngIf="erstzulassungsdatum.hasError('matDatepickerMin')">{{ 'MINVALUE' | translate:{'value': erstzulassungsdatumMinDate | date} }}</mat-error>
            <mat-error *ngIf="erstzulassungsdatum.hasError('matDatepickerMax')">{{ 'MAXVALUE' | translate:{'value': dateService.getErstzulassungsdatumMaxDate() | date} }}</mat-error>
          </mat-form-field>
        </div>
      </ng-template>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <ng-template [ngTemplateOutlet]="antriebsartTemplate"></ng-template>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <div *ngIf="showHybridart">
        <div *ngIf="complete; else _hybridart">
          <div class="input">
            <label class="input__label" [for]="idprefix + '_hybridart_' + risikoIndex">Hybridart:</label>
            <mat-form-field>
              <input matInput [id]="idprefix + '_hybridart_' + risikoIndex" [value]="dataService.hybridarten.get(hybridart.value * 1)" disabled>
            </mat-form-field>
          </div>
        </div>
        <ng-template #_hybridart>
          <div class="input_radio">
            <app-label [control]="hybridart" [for]="idprefix + '_hybridart_' + risikoIndex">Hybridart</app-label>
            <mat-radio-group [id]="idprefix + '_hybridart_' + risikoIndex" formControlName="hybridart">
              <mat-radio-button value="1">nicht extern aufladbar, FHEV - Vollhybrid/MHEV - Mildhybrid</mat-radio-button>
              <mat-radio-button value="2">extern aufladbar, PHEV - Plug-In Hybrid</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="hybridart.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <ng-template [ngTemplateOutlet]="emissionCo2Template" *ngIf="!motorrad"></ng-template>
    </div>
    <div class="col col-xs-12" [ngClass]="{' col-sm-4': showHubraumCcm, ' col-sm-12': !showHubraumCcm}">
      <div *ngIf="showHubraumCcm">
        <div *ngIf="complete; else _hubraumCcm">
          <div class="input">
            <label class="input__label" [for]="idprefix + '_hubraumCcm_' + risikoIndex">Hubraum:</label>
            <mat-form-field>
              <input matInput [id]="idprefix + '_hubraumCcm_' + risikoIndex" [value]="hubraumCcm.value" disabled>
            </mat-form-field>
          </div>
        </div>
        <ng-template #_hubraumCcm>
          <div class="input">
            <div class="text_info">
              <app-label [control]="hubraumCcm" class="input__label" [for]="idprefix + '_hubraumCcm_' + risikoIndex">{{ expertMode ? 'Hubraum (ccm)' : 'Wieviel ccm hat das Motorrad?' }}</app-label>
              <div class="info">
                <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('ROUNDPSINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
              </div>
            </div>
            <mat-form-field>
              <input matInput [id]="idprefix + '_hubraumCcm_' + risikoIndex" [maxlength]="5" formControlName="hubraumCcm">
              <mat-error *ngIf="hubraumCcm.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
              <mat-error *ngIf="hubraumCcm.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
              <mat-error *ngIf="!hubraumCcm.hasError('pattern') && hubraumCcm.hasError('min')">{{ 'MINVALUE' | translate:{'value': hubraumCcm.errors.min.min} }}</mat-error>
              <mat-error *ngIf="!hubraumCcm.hasError('pattern') && hubraumCcm.hasError('max')">{{ 'MAXVALUE' | translate:{'value': hubraumCcm.errors.max.max} }}</mat-error>
            </mat-form-field>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="col col-xs-12" [ngClass]="{' col-sm-4': showHubraumCcm, ' col-sm-6': !showHubraumCcm}">
      <div *ngIf="showLeistungKw">
        <div *ngIf="complete; else _leistungKw">
          <div class="input">
            <label class="input__label" [for]="idprefix + '_leistungKw_' + risikoIndex">KW:</label>
            <mat-form-field>
              <input matInput [id]="idprefix + '_leistungKw_' + risikoIndex" [value]="leistungKw.value" disabled>
            </mat-form-field>
          </div>
        </div>
        <ng-template #_leistungKw>
          <div class="input">
            <div class="text_info">
              <app-label [control]="leistungKw" class="input__label" [for]="idprefix + '_leistungKw_' + risikoIndex">{{ expertMode ? antriebsart.value?.Key === '13' || antriebsart.value?.Key === '15' ? 'Leistung in kW (Verbrennungsmotor)' : 'Leistung in kW' : antriebsart.value?.Key === '13' || antriebsart.value?.Key === '15' ? motorrad ? 'Wieviel kW hat der Verbrennungsmotor Ihres Motorrades?' : 'Wieviel kW hat der Verbrennungsmotor Ihres Fahrzeuges?' : motorrad ? 'Wieviel kW hat Ihr Motorrad?' : 'Wieviel kW hat Ihr Fahrzeug?' }}</app-label>
              <div class="info">
                <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('ROUNDPSINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
              </div>
            </div>
            <mat-form-field>
              <input type="number" matInput [id]="idprefix + '_leistungKw_' + risikoIndex" [maxlength]="5" formControlName="leistungKw">
              <mat-error *ngIf="leistungKw.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
              <mat-error *ngIf="leistungKw.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
              <mat-error *ngIf="!leistungKw.hasError('pattern') && leistungKw.hasError('min')">{{ 'MINVALUE' | translate:{'value': leistungKw.errors.min.min} }}</mat-error>
              <mat-error *ngIf="!leistungKw.hasError('pattern') && leistungKw.hasError('max')">{{ 'MAXVALUE' | translate:{'value': leistungKw.errors.max.max} }}</mat-error>
            </mat-form-field>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="col col-xs-12" [ngClass]="{' col-sm-4': showHubraumCcm, ' col-sm-6': !showHubraumCcm}">
      <div *ngIf="showLeistungPs">
        <div *ngIf="complete; else _leistungPs">
          <div class="input">
            <label class="input__label" [for]="idprefix + '_leistungPs_' + risikoIndex">PS:</label>
            <mat-form-field>
              <input matInput [id]="idprefix + '_leistungPs_' + risikoIndex" [value]="leistungPs.value" disabled>
            </mat-form-field>
          </div>
        </div>
        <ng-template #_leistungPs>
          <div class="input">
            <div class="text_info">
              <app-label [control]="leistungPs" class="input__label" [for]="idprefix + '_leistungPs_' + risikoIndex">{{ expertMode ? antriebsart.value?.Key === '13' || antriebsart.value?.Key === '15' ? 'Leistung in PS (Verbrennungsmotor)' : 'Leistung in PS' : antriebsart.value?.Key === '13' || antriebsart.value?.Key === '15' ? motorrad ? 'Wieviel PS hat der Verbrennungsmotor Ihres Motorrades?' : 'Wieviel PS hat der Verbrennungsmotor Ihres Fahrzeuges?' : motorrad ? 'Wieviel PS hat Ihr Motorrad?' : 'Wieviel PS hat Ihr Fahrzeug?' }}</app-label>
              <div class="info">
                <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('ROUNDPSINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
              </div>
            </div>
            <mat-form-field>
              <input type="number" matInput [id]="idprefix + '_leistungPs_' + risikoIndex" [maxlength]="5" formControlName="leistungPs">
              <mat-error *ngIf="leistungPs.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
              <mat-error *ngIf="!leistungPs.hasError('pattern') && leistungPs.hasError('min')">{{ 'MINVALUE' | translate:{'value': leistungPs.errors.min.min} }}</mat-error>
              <mat-error *ngIf="!leistungPs.hasError('pattern') && leistungPs.hasError('max')">{{ 'MAXVALUE' | translate:{'value': leistungPs.errors.max.max} }}</mat-error>
            </mat-form-field>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <div *ngIf="showEigengewichtKg">
        <div *ngIf="complete; else _eigengewichtKg">
          <div class="input">
            <label class="input__label" [for]="idprefix + '_eigengewichtKg_' + risikoIndex">Eigengewicht:</label>
            <mat-form-field>
              <input matInput [id]="idprefix + '_eigengewichtKg_' + risikoIndex" [value]="eigengewichtKg.value" disabled>
            </mat-form-field>
          </div>
        </div>
        <ng-template #_eigengewichtKg>
          <div class="input">
            <app-label [control]="eigengewichtKg" class="input__label" [for]="idprefix + '_eigengewichtKg_' + risikoIndex">Eigengewicht</app-label>
            <mat-form-field>
              <input matInput [id]="idprefix + '_eigengewichtKg_' + risikoIndex" placeholder="in kg" [maxlength]="8" formControlName="eigengewichtKg">
              <mat-error *ngIf="eigengewichtKg.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
              <mat-error *ngIf="eigengewichtKg.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
              <mat-error *ngIf="!eigengewichtKg.hasError('pattern') && eigengewichtKg.hasError('min')">{{ 'MINVALUE' | translate:{'value': eigengewichtKg.errors.min.min} }}</mat-error>
              <mat-error *ngIf="!eigengewichtKg.hasError('pattern') && eigengewichtKg.hasError('max')">{{ 'MAXVALUE' | translate:{'value': eigengewichtKg.errors.max.max} }}</mat-error>
            </mat-form-field>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <div *ngIf="!complete">
        <div class="custom_select" *ngIf="showVerwendungsbestimmung">
          <app-label [control]="verwendungsbestimmung" class="custom-select__label" [for]="idprefix + '_verwendungsbestimmung_' + risikoIndex">{{ expertMode ? 'Verwendungsbestimmung' : 'Welche Verwendungsbestimmung ist in der Zulassungsbescheinigung eingetragen?' }}</app-label>
          <mat-form-field>
            <mat-select [id]="idprefix + '_verwendungsbestimmung_' + risikoIndex" [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" formControlName="verwendungsbestimmung" [compareWith]="lookupService.compareValues">
              <mat-option *ngFor="let vb of verwendungsbestimmungen | async" [value]="vb">{{ vb.Value }}</mat-option>
            </mat-select>
            <mat-error *ngIf="verwendungsbestimmung.hasError('required')">{{ 'CONFIRMREQUIRED' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <div *ngIf="showNutzlastKg">
        <div *ngIf="complete; else _nutzlastKg">
          <div class="input">
            <label class="input__label" [for]="idprefix + '_nutzlastKg_' + risikoIndex">Nutzlast:</label>
            <mat-form-field>
              <input matInput [id]="idprefix + '_nutzlastKg_' + risikoIndex" [value]="nutzlastKg.value" disabled>
            </mat-form-field>
          </div>
        </div>
        <ng-template #_nutzlastKg>
          <div class="input">
            <app-label [control]="nutzlastKg" class="input__label" [for]="idprefix + '_nutzlastKg_' + risikoIndex">Nutzlast:</app-label>
            <mat-form-field>
              <input matInput [id]="idprefix + '_nutzlastKg_' + risikoIndex" placeholder="in kg" [maxlength]="8" formControlName="nutzlastKg">
              <mat-error *ngIf="nutzlastKg.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
              <mat-error *ngIf="nutzlastKg.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
              <mat-error *ngIf="!nutzlastKg.hasError('pattern') && nutzlastKg.hasError('min')">{{ 'MINVALUE' | translate:{'value': nutzlastKg.errors.min.min} }}</mat-error>
              <mat-error *ngIf="!nutzlastKg.hasError('pattern') && nutzlastKg.hasError('max')">{{ 'MAXVALUE' | translate:{'value': nutzlastKg.errors.max.max} }}</mat-error>
            </mat-form-field>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <div *ngIf="showNutzlastKg">
        <div *ngIf="complete; else _gesamtgewichtKg">
          <div class="input">
            <label class="input__label" [for]="idprefix + '_gesamtgewichtKg_' + risikoIndex">Gesamtgewicht:</label>
            <mat-form-field>
              <input matInput [id]="idprefix + '_gesamtgewichtKg_' + risikoIndex" [value]="gesamtgewichtKg.value" disabled>
            </mat-form-field>
          </div>
        </div>
        <ng-template #_gesamtgewichtKg>
          <div class="input" *ngIf="showGesamtgewichtKg">
            <app-label [control]="gesamtgewichtKg" class="input__label" [for]="idprefix + '_gesamtgewichtKg_' + risikoIndex">Gesamtgewicht:</app-label>
            <mat-form-field>
              <input matInput [id]="idprefix + '_gesamtgewichtKg_' + risikoIndex" placeholder="in kg" [maxlength]="8" formControlName="gesamtgewichtKg">
              <mat-error *ngIf="gesamtgewichtKg.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
              <mat-error *ngIf="gesamtgewichtKg.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
              <mat-error *ngIf="!gesamtgewichtKg.hasError('pattern') && gesamtgewichtKg.hasError('min')">{{ 'MINVALUE' | translate:{'value': gesamtgewichtKg.errors.min.min} }}</mat-error>
              <mat-error *ngIf="!gesamtgewichtKg.hasError('pattern') && gesamtgewichtKg.hasError('max')">{{ 'MAXVALUE' | translate:{'value': gesamtgewichtKg.errors.max.max} }}</mat-error>
            </mat-form-field>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <ng-template [ngTemplateOutlet]="emissionCo2Template" *ngIf="motorrad"></ng-template>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <div *ngIf="showHoechstGeschwindigkeitKmh">
        <div *ngIf="complete; else _hoechstGeschwindigkeitKmh">
          <div class="input">
            <label class="input__label" [for]="idprefix + '_hoechstGeschwindigkeitKmh_' + risikoIndex">Höchstgeschwindigkeit (km/h):</label>
            <mat-form-field>
              <input matInput [id]="idprefix + '_hoechstGeschwindigkeitKmh_' + risikoIndex" [value]="hoechstGeschwindigkeitKmh.value" disabled>
            </mat-form-field>
          </div>
        </div>
        <ng-template #_hoechstGeschwindigkeitKmh>
          <div class="input">
            <app-label [control]="hoechstGeschwindigkeitKmh" class="input__label" [for]="idprefix + '_hoechstGeschwindigkeitKmh_' + risikoIndex">{{ expertMode ? 'Höchstgeschwindigkeit (km/h)' : 'Bitte geben Sie die Höchstgeschwindigkeit des Fahrzeuges an (in km/h)' }}:</app-label>
            <mat-form-field>
              <input matInput [id]="idprefix + '_hoechstGeschwindigkeitKmh_' + risikoIndex" [maxlength]="5" formControlName="hoechstGeschwindigkeitKmh">
              <mat-error *ngIf="hoechstGeschwindigkeitKmh.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
              <mat-error *ngIf="hoechstGeschwindigkeitKmh.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
              <mat-error *ngIf="!hoechstGeschwindigkeitKmh.hasError('pattern') && hoechstGeschwindigkeitKmh.hasError('min')">{{ 'MINVALUE' | translate:{'value': hoechstGeschwindigkeitKmh.errors.min.min} }}</mat-error>
              <mat-error *ngIf="!hoechstGeschwindigkeitKmh.hasError('pattern') && hoechstGeschwindigkeitKmh.hasError('max')">{{ 'MAXVALUE' | translate:{'value': hoechstGeschwindigkeitKmh.errors.max.max} }}</mat-error>
            </mat-form-field>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <div *ngIf="showAnzahlPlaetze">
        <div *ngIf="complete; else _anzahlPlaetze">
          <div class="input">
            <label class="input__label" [for]="idprefix + '_anzahlPlaetze_' + risikoIndex">Plätze:</label>
            <mat-form-field>
              <input matInput [id]="idprefix + '_anzahlPlaetze_' + risikoIndex" [value]="anzahlPlaetze.value" disabled>
            </mat-form-field>
          </div>
        </div>
        <ng-template #_anzahlPlaetze>
          <div class="input_radio">
            <app-label [control]="anzahlPlaetze" [for]="idprefix + '_anzahlPlaetze_' + risikoIndex">Anzahl Plätze:</app-label>
            <mat-radio-group [id]="idprefix + '_anzahlPlaetze_' + risikoIndex" formControlName="anzahlPlaetze">
              <mat-radio-button value="1">1</mat-radio-button>
              <mat-radio-button value="2">2</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="anzahlPlaetze.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <div class="input" *ngIf="showFahrgestellnummer">
        <div class="text_info">
          <app-label [control]="fahrgestellnummer" class="input__label" [for]="idprefix + '_fahrgestellnummer_' + risikoIndex">Fahrgestellnummer:</app-label>
          <div class="info">
            <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('FAHRGESTELLNUMMERINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
          </div>
        </div>
        <mat-form-field>
          <input maxlength="30" matInput [id]="idprefix + '_fahrgestellnummer_' + risikoIndex" [value]="fahrgestellnummer.value | uppercase" formControlName="fahrgestellnummer">
          <mat-error *ngIf="fahrgestellnummer.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <div class="input_radio" *ngIf="showVerwendungsbestimmungJaNein">
        <div class="text_info">
          <app-label [control]="verwendungsbestimmungJaNein" for="verwendungsbestimmungJaNein" *ngIf="!isZugMaschineSelected; else zug_context">
            {{
 expertMode ?
            'Hat das Fahrzeug eine besondere Verwendungsbestimmung?' : 'Hat Ihr Fahrzeug eine besondere Verwendungsbestimmung?'
            }}
          </app-label>
          <ng-template #zug_context>
            <app-label [control]="verwendungsbestimmungJaNein" for="verwendungsbestimmungJaNein">
              {{
 expertMode ? "Hat das Fahrzeug die Verwendungsbestimmung „zur
              Verwendung im Rahmen eines land- und forstwirtschaftlichen Betriebes bestimmt“?" : "Hat das Fahrzeug die
              Verwendungsbestimmung „zur Verwendung im Rahmen eines land- und forstwirtschaftlichen Betriebes
              bestimmt“?"
              }}
            </app-label>
          </ng-template>
          <div class="info">
            <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get(zugmaschineVerwendungsbestimmungInfoKey) | async) as res" (click)="popupService.openInfoPopup(res)"></div>
          </div>
        </div>
        <mat-radio-group id="verwendungsbestimmungJaNein" formControlName="verwendungsbestimmungJaNein">
          <mat-radio-button value="ja">Ja</mat-radio-button>
          <mat-radio-button value="nein">Nein</mat-radio-button>
        </mat-radio-group>
        <mat-error *ngIf="verwendungsbestimmungJaNein.hasError('required')  && parentFormGroupDirective.submitted">
          {{
          'SELECTREQUIRED' | translate
          }}
        </mat-error>
      </div>
      <div class="text_info" *ngIf="verwendungsbestimmungJaNein.hasError('invalid')">
        <div class="custom-select__label red-error-text-circle" for="verwendungsbestimmungJaNein">
          Diese
          Verwendungsbestimmung fällt unter ein anfragepflichtiges Sonderrisiko.
          <span [innerHTML]="(expertMode? translateService.get('SPEZIELLEANFRAGEEXPERT')  : translateService.get('SPEZIELLEANFRAGE'))|async"></span>
        </div>
        <div class="info" *ngIf="!isZugMaschineSelected">
          <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('ANNAHMERICHTLINIENINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
        </div>
      </div>
    </div>

  </div>
  <ng-template #emissionCo2Template>
    <div *ngIf="complete; else _emissionCo2">
      <div class="input" *ngIf="showEmissionCo2">
        <label class="input__label" [for]="idprefix + '_emissionCo2_' + risikoIndex">CO₂-Ausstoß:</label>
        <mat-form-field>
          <input matInput [id]="idprefix + '_emissionCo2_' + risikoIndex" [value]="emissionCo2.value" disabled>
        </mat-form-field>
      </div>
    </div>
    <ng-template #_emissionCo2>
      <div class="input" *ngIf="showEmissionCo2">
        <div class="text_info">
          <app-label [control]="emissionCo2" class="input__label" [for]="idprefix + '_emissionCo2_' + risikoIndex">{{ expertMode ? 'CO₂-Ausstoß (g/km)' : 'Wie hoch ist der CO₂-Ausstoß des Fahrzeuges in g/km?' }}</app-label>
        </div>
        <mat-form-field>
          <input matInput [id]="idprefix + '_emissionCo2_' + risikoIndex" placeholder="{{motorrad ? 'Kombinierter WMTC-Wert' : 'Kombinierter WLTP-Wert'}}" [maxlength]="5" formControlName="emissionCo2">
          <mat-error *ngIf="emissionCo2.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
          <mat-error *ngIf="emissionCo2.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
          <mat-error *ngIf="!emissionCo2.hasError('pattern') && emissionCo2.hasError('min')">{{ 'MINVALUE' | translate:{'value': emissionCo2.errors.min.min} }}</mat-error>
          <mat-error *ngIf="!emissionCo2.hasError('pattern') && emissionCo2.hasError('max')">{{ 'MAXVALUE' | translate:{'value': emissionCo2.errors.max.max} }}</mat-error>
        </mat-form-field>
      </div>
    </ng-template>
  </ng-template>
  <ng-template #antriebsartTemplate>
    <div class="row">
      <div class="col col-xs-12 col-sm-12">
        <div *ngIf="complete; else _antriebsart">
          <div class="input" *ngIf="showAntriebsart">
            <label class="input__label" [for]="idprefix + '_antriebsart_' + risikoIndex">Antriebsart:</label>
            <mat-form-field>
              <input matInput [id]="idprefix + '_antriebsart_' + risikoIndex" [value]="antriebsart.value?.Value" disabled>
            </mat-form-field>
          </div>
        </div>
        <ng-template #_antriebsart>
          <div class="custom_select" *ngIf="showAntriebsart">
            <div class="text_info">
              <app-label [control]="antriebsart" class="custom-select__label" [for]="idprefix + '_antriebsart_' + risikoIndex">{{ expertMode ? 'Antriebsart' : motorrad ? 'Welche Antriebsart hat Ihr Motorrad?' : 'Welche Antriebsart hat Ihr Auto?' }}</app-label>
              <div class="info">
                <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('ANTRIEBSARTINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
              </div>
            </div>
            <mat-form-field>
              <mat-select [id]="idprefix + '_antriebsart_' + risikoIndex" [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" formControlName="antriebsart" [compareWith]="lookupService.compareValues">
                <mat-option *ngFor="let aa of antriebsarten | async" [value]="aa">{{ aa.Value }}</mat-option>
              </mat-select>
              <mat-error *ngIf="antriebsart.hasError('required')">{{ 'CONFIRMREQUIRED' | translate }}</mat-error>
            </mat-form-field>
          </div>
        </ng-template>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <div class="input" *ngIf="showAndereAntriebsart">
          <app-label [control]="andereAntriebsart" class="input__label" [for]="idprefix + '_andereAntriebsart_' + risikoIndex">Welche Antriebsart?</app-label>
          <mat-form-field>
            <input matInput [id]="idprefix + '_andereAntriebsart_' + risikoIndex" [maxlength]="50" formControlName="andereAntriebsart">
            <mat-error *ngIf="andereAntriebsart.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </ng-template>
</form>
